<template>
	<component :is="component" :data="data" :moduleId="moduleId" />
</template>

<script setup>
import OverviewStandard from '@rebuild/materials/shared/widget_shell/Overview.vue';
import OverviewInSH600519 from './SH600519_overview.vue';
import { contentData } from './content';
import { computed } from 'vue';

const props = defineProps({
	data: {
		type: String,
		default: ''
	},
	moduleId: {
		type: String,
		default: ''
	}
});

const component = computed(() => {
	return contentData.displayModuleIds.includes(props.moduleId) ? OverviewInSH600519 : OverviewStandard;
});
</script>
